<!--
  ~ Copyright (c) 2026 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<p-dialog [header]="translationSchema.task.list.closeMessage | translate"
          [visible]="visible()" (visibleChange)="visible.set($event)" [modal]="true"
          [style]="{ 'max-width': '30rem' }">
  <p style="white-space: normal; word-wrap: break-word;">{{ translationSchema.task.list.closeBody | translate }}</p>
  <ng-template pTemplate="footer">
    <button pButton class="p-button-text"
            [label]="translationSchema.utils.close | translate"
            (click)="visible.set(false)"></button>
    <button pButton
            [label]="translationSchema.task.list.closeTask | translate"
            (click)="closeTask()"></button>
  </ng-template>
</p-dialog>
